import React from 'react';
import InfoListingPage from '../components/InfoListingPage';

const items = [
  {
    title: 'Plymouth Market',
    distance: '0.6 miles from the hotel',
    image: 'PlymouthMarket.jpg',
    description: 'A food haven offering an amazing range of cuisines, hence completely worth a visit! From mouthwatering Asian, American and Italian cuisines to traditional British cafes, the Plymouth market caters to everyone’s taste and preferences!'
  },
  {
    title: 'Toot – Persian Cuisine',
    distance: '1.2 miles from the hotel',
    image: 'Toot PersianCuisine.jpg',
    description: 'Fancy staying in for a while without the hassle of waiting at restaurants? Try out the mouthwatering takeaway menu offered by Toot, a quirky little joint for Persian cuisine. Although its chirpy ethnic ambience might just make you change your mind about the take away! From their famous Kofte Kebab Wraps to their delicious Koobideh, Toot is definitely worth a try!'
  },
  {
    title: 'Rockfish Seafood & Chips',
    distance: '0.4 miles from the hotel',
    image: 'RockfishSeafood&Chips.jpg',
    description: 'Looking for a relaxed environment to enjoy some great traditional fish chips? Rockfish is the place for you! Located right next to the fish market, this restaurant serves you the fresh catch of the day. The perfect location for a family seafood restaurant!'
  },
  {
    title: 'The Dock',
    distance: '0.8 miles from the hotel',
    image: 'TheDock.jpg',
    description: 'A charming family-run restaurant that speaks volumes with its beautiful coastal views and a mouthwatering menu, The Dock is certainly an experience to cherish! Making your visit to Plymouth worth its while, this wonderful restaurant is located in the city’s Coastal Quarter in Millbay.'
  },
  {
    title: 'Kuku Restaurant',
    distance: '0.4 miles from the hotel',
    image: 'KukuRestaurant.jpg',
    description: 'Set in a Grade II listed building, just seconds away from the bustle of Plymouth\'s city centre; KUKU offers the perfect sanctuary for both the casual and professional Japanese food enthusiasts.\n\nDishes are prepared using innovative food combinations, combining local seasonal ingredients; crossing boundaries by pairing traditional Japanese offerings with new and refreshing flavours and texture.'
  },
  {
    title: 'The Greedy Goose',
    distance: '0.4 miles from the hotel',
    image: 'TheGreedyGoose.jpg',
    description: 'Fancy a scrumptious meal in Plymouth’s oldest building? The Greedy Goose is the place for you! With a menu based on seasonal ingredients and an interior of rustic stone walls and wooden paneling, this restaurant is definitely worth a visit when in Plymouth.'
  },
  {
    title: 'The Treasury Lounge Bar and Restaurant, Catherine Street',
    distance: '0.5 miles from the hotel',
    image: 'TreasuryLounge.jpg',
    description: 'Located within Plymouth’s 19th century treasury building, bar and restaurant is the perfect setting to enjoy a drink with a variety of over 35 cocktails as well as fresh handmade juices and super-premium spirits to choose from.'
  },
  {
    title: 'Slug & Lettuce, Berkeley Square',
    distance: '0.3 miles from the hotel',
    image: 'Slug&Lettuce.jpg',
    description: 'With a beautiful outdoor setting to enjoy the sunny days of Plymouth, the Slug & Lettuce is a vibrant restaurant and bar offering a variety of classic cocktails, mocktails and sharing cocktails. Popular for its two-for-one deals, the Slug & Lettuce is a great option for drinks, tapas and much more!'
  },
  {
    title: 'Le Vignoble',
    distance: '1.3 miles from the hotel',
    image: 'LeVignoble.jpg',
    description: 'Plymouth’s independent wine lounge, Le Vignoble, is the place to relax and unwind for an evening drink. Boasting a variety of over 250 different wines, champagnes and liqueurs from across the world and located within the historical Royal William Yard, this wine lounge is considered the ideal spot to enjoy the finer side of life. Their monthly wine tasting events are certainly worth the hype!'
  }
];

const FoodAndDrink = () => (
  <InfoListingPage
    title="Food and Drink"
    description="Discover some of the best places to eat and drink near Grosvenor Plymouth, from local seafood favourites to vibrant market dining and stylish wine lounges."
    items={items}
  />
);

export default FoodAndDrink;
